import { NotifyApiDatasource } from '../data/datasources/notify-api.datasource';
import { NotifyRepositoryImpl } from '../data/repositories/notify.repository.impl';

const api = new NotifyApiDatasource();
const repository = new NotifyRepositoryImpl(api);

export const notifyContainer = { repository };
